<template>
  <div>
    <b-textarea
      v-model="dialogData.text"
      :placeholder="dialog.dialogData.placeholder"
      :rows="5"
      :error-messages="getErrorMessages(v$.text)"></b-textarea>
  </div>
</template>

<script>
import { BTextarea } from 'best-modules/components'
import { getErrorMessages } from '@/utils/helpers.js'
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'Textarea',
  components: { BTextarea },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup() {
    const dialogData = reactive({ text: null })
    const rules = { text: { required } }
    const v$ = useVuelidate(rules, dialogData)

    const submit = () => {
      return Promise.resolve(dialogData.text)
    }

    return { dialogData, v$, submit }
  },
}
</script>
